<template>
  <v-container id="attendance-list">
    <app-city-header :payload="payload"> </app-city-header>

    <v-row>
      <v-col>Reuniões de Acompanhamento</v-col>
      <!-- <v-col
        class="text-right"
      >
        <v-btn
          v-if="(isAdmin)"
          outlined
          color="success"
          class="ml-3"
          @click="acompanhamentoFinalizacao"
        >
          Acompanhamento de Finalização
        </v-btn>
      </v-col> -->
      <v-col class="text-right">
        <app-modal-insert-attendance
          v-if="groupsConfig.novoAcompanhamento && config.novoAcompanhamento"
          :dialog="false"
        >
        </app-modal-insert-attendance>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="getHeader()"
          :items="acompanhamentos"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.nome="{ item }">
            <a
              :href="
                './#/cidade/' +
                payload.municipioId +
                '/acompanhamento/obter/' +
                item.acompanhamentoId
              "
              >{{
                item.nome === "Diagnóstico" && isSala
                  ? "Acompanhamento Geral"
                  : item.nome
              }}</a
            >
          </template>

          <template v-slot:item.criacao="{ item }">
            {{ item.criacao | moment("DD/MM/YYYY") }}
          </template>

          <template v-slot:item.finalizado="{ item }">
            <span v-if="item.finalizado === true">
              <v-icon color="primary"> mdi-check-circle-outline </v-icon>
            </span>

            <span v-if="item.finalizado === false">
              <v-icon color="error"> mdi-cancel </v-icon>
            </span>
          </template>

          <template v-slot:item.acoes="{ item }">
            <a
              :href="
                './#/cidade/' +
                payload.municipioId +
                '/pmd/' +
                item.acompanhamentoId
              "
              >Plano de Ação</a
            >
          </template>

          <template slot="no-data">
            <span> Nenhum acompanhamento retornado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertAttendance from "./ModalInsert";
import { attendanceAPI } from "@/modules/attendance";
import { mapActions, mapGetters } from "vuex";
import { AppCityHeader } from "@/modules/city";
import { userAPI } from "@/modules/user/components/UserAPI";
import moment from "moment";
import {
  statusRelacionamentoEnum,
  statusContratoEnum,
  statusRelacionamentoSeloEnum,
} from "@/types";
import { cityAPI } from "@/modules/city";

export default {
  components: {
    AppModalInsertAttendance,
    AppCityHeader,
  },
  data() {
    return {
      headers: [
        { text: "Título", value: "nome" },
        { text: "Criado em", value: "criacao" },
        { text: "Status", value: "finalizado" },
        { text: "Sim", value: "sim" },
        { text: "Não", value: "nao" },
        { text: "Pontos", value: "pontos" },
        { text: "Ações", value: "acoes" },
      ],
      headersSemPontos: [
        { text: "Título", value: "nome" },
        { text: "Criado em", value: "criacao" },
        { text: "Status", value: "finalizado" },
        { text: "Sim", value: "sim" },
        { text: "Não", value: "nao" },
        { text: "Ações", value: "acoes" },
      ],
      user: JSON.parse(localStorage.getItem("user")),
      payload: {
        municipioId: this.$route.params.id,
      },
      municipio: null,
      statusContratoEnum: statusContratoEnum,
      statusRelacionamentoEnum: statusRelacionamentoEnum,
      statusRelacionamentoSeloEnum: statusRelacionamentoSeloEnum,
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      acompanhamentos: [
        {
          municipio: {
            diagnostico: false,
          },
        },
      ],
    };
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio",
    ]),
    getHeader() {
      if (
        this.isFullAdmin ||
        (this.config.visualizarPontosMedalha &&
          this.groupsConfig.visualizarPontosMedalha &&
          this.getMunicipioVigente())
      ) {
        return this.headers;
      } else {
        return this.headersSemPontos;
      }
    },
    getMunicipioVigente() {
      let isVigente = true;
      if (this.municipio) {
        if (this.$store.state.uf === "RJ") {
          isVigente =
            this.statusContratoEnum.cidadeEmpreendedora ===
              this.municipio.statusContratoId &&
            !this.isSala &&
            !this.isAT &&
            this.municipio.statusId === this.statusRelacionamentoEnum.vigente;
        } else {
          isVigente =
            (this.isSala &&
              this.municipio.statusId ===
                this.statusRelacionamentoSeloEnum.participante) ||
            this.municipio.statusId === this.statusRelacionamentoEnum.vigente;
        }
      }

      return isVigente;
    },
    geUser() {
      userAPI
        .findUser(this.user.usuarioId)
        .then(({ data: usuario }) => {
          this.user = usuario;
          this.listAttendances();
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error(
            "Erro ao gerar acompanhamento de finalização"
          );
        });
    },
    getCity() {
      cityAPI.get(this.payload.municipioId).then((item) => {
        this.setLoading(false);

        this.municipio = item.data;
      });
    },
    sort() {
      this.acompanhamentos = this.acompanhamentos.sort(function (a, b) {
        a.createdAt = moment(a.criacao, "DD/MM/YYYY");
        b.createdAt = moment(b.criacao, "DD/MM/YYYY");
        if (a.createdAt === b.createdAt) {
          if (
            a["nome"].normalize("NFD").replace(/[\u0300-\u036f]/g, "") <
            b["nome"].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          ) {
            return -1;
          }
          if (
            a["nome"].normalize("NFD").replace(/[\u0300-\u036f]/g, "") >
            b["nome"].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          ) {
            return 1;
          }
        }

        if (a.createdAt > b.createdAt) {
          return -1;
        }
        if (a.createdAt < b.createdAt) {
          return 1;
        }
        return 0;
      });
    },
    listAttendances() {
      attendanceAPI
        .list(this.$route.params.id)
        .then(async (resp) => {
          this.acompanhamentos = resp.data;

          if (!this.user.grupo.verTodosEixos) {
            this.acompanhamentos = this.acompanhamentos.filter(
              (item) =>
                this.user.permissoes.some((per) => {
                  return (
                    item.nome.indexOf(per.eixo.nome) > -1 &&
                    per.municipioId == this.$route.params.id
                  );
                }) || item.nome === "Diagnóstico"
            );
          }
          this.sort();
          await this.setConsultorCondutorMunicipio(this.$route.params.id);
          await this.setConsultorEspecialistaMunicipio(this.$route.params.id);
          await this.setAnalistaMunicipio(this.$route.params.id);
          await this.setADMunicipio(this.$route.params.id);

          this.setLoading(false);
        })
        .catch((err) => {
          console.log("Erro ao listar acompanhamentos: ", err);
          this.setLoading(false);
          this.$notification.error("Erro ao obter acompanhamentos");
        });
    },
    acompanhamentoFinalizacao() {
      attendanceAPI
        .finalizacao(this.$route.params.id)
        .then((resp) => {
          this.listAttendances();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            "Erro ao gerar acompanhamento de finalização"
          );
        });
    },
  },
  beforeMount() {
    this.setLoading(true);

    this.getCity();
  },
  mounted() {
    this.setLoading(true);

    this.geUser();
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "uf",
      "isSala",
      "isFullAdmin",
    ]),
  },
};
</script>
